import React from "react";
import "./Footer.css";
import { Link, NavLink } from "react-router-dom";

class Footer extends React.Component {
  render() {
    const date = new Date();
    const year = date.getFullYear();
    return (
      <footer className="row">
        <div className="container">
          <div className="row">
            <div className="col-12 text-12 text-center">
              <NavLink
                to="/budget"
                className={
                  localStorage.getItem("businessid") ? "links" : "d-none"
                }
                exact
                activeClassName="activeLink"
                target="_blank"
              >
                Calculator
              </NavLink>{" "}
              {localStorage.getItem("businessid") ? "| " : " "}
              <NavLink
                to="/privacy-policy"
                className="links"
                exact
                activeClassName="activeLink"
                target="_blank"
              >
                Privacy
              </NavLink>{" "}
              |{" "}
              <NavLink
                to="/ticketing-policy"
                className={"links"}
                exact
                activeClassName="activeLink"
                target="_blank"
              >
                Ticket policy
              </NavLink>{" "}
              |{" "}
              <NavLink
                to="/terms-conditions"
                className={"links"}
                exact
                activeClassName="activeLink"
                target="_blank"
              >
                T's & Cs
              </NavLink>
              {localStorage.getItem("businessid") ? "" : " |"}{" "}
              <NavLink
                to="/refund-policy"
                className={
                  localStorage.getItem("customerid") ? "links" : "d-none"
                }
                exact
                activeClassName="activeLink"
                target="_blank"
              >
                Refund policy
              </NavLink>
            </div>
            {/* <div className="col-lg-2">&copy; {year} Karamale</div> */}
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;
